import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Layout',
    component: () => import('@/views/Layout.vue'),
    redirect: '/claim-form',
    children: [
      {
        path: '/claim-form',
        name: 'ClaimForm',
        component: () => import('@/views/ClaimForm.vue')
      },
      {
        path: '/claim-form/:manifest',
        name: 'ClaimFormManifest',
        props: true,
        component: () => import('@/views/ClaimForm.vue')
      },
      {
        path: '/:page',
        name: 'DynamicPage',
        props: true,
        component: () => import('@/views/ClaimForm.vue')
      },
    ],
  }
]

const router = new VueRouter({
  routes
})

export default router